import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { GerenciarPerfisUsuariosApiService } from '../../services/gerenciar-perfis-usuarios-api.service';
import { Papel } from '../../models/papel';
import { Permissao } from '../../models/permissao';
import { MessageService } from '@services/message.service';
import { ModuloEnumNome } from '@models/enums/modulo-enum';
import { ItemSelecao } from '../shared/paineis-selecao-checkboxes/item-selecao';
import { PaineisSelecaoCheckboxesComponent } from '../shared/paineis-selecao-checkboxes/paineis-selecao-checkboxes.component';

const NOME_PAPEL_ADMIN = 'ADMIN';

@Component({
  selector: 'app-editar-permissoes-papel',
  templateUrl: './editar-permissoes-papel.component.html',
  styleUrl: './editar-permissoes-papel.component.scss',
  standalone: false,
})
export class EditarPermissoesPapelComponent {

  @Input() papeis: Papel[] = [];

  @Input() set permissoes(value: Permissao[]) {
    this._permissoes = value;
    if (this.papelSelecionadoId !== null) this.computarItensDireita();
  }
  get permissoes(): Permissao[] { return this._permissoes; }
  private _permissoes: Permissao[] = [];

  @Output() papeisChange = new EventEmitter<Papel[]>();
  @ViewChild(PaineisSelecaoCheckboxesComponent) paineis!: PaineisSelecaoCheckboxesComponent;

  get itensEsquerda(): ItemSelecao[] {
    return this.papeis.map(p => ({ id: p.id, label: p.nome }));
  }

  itensDireita: ItemSelecao[] = [];
  tituloDireita: string = '';
  salvando = false;
  papelSelecionadoEhAdmin = false;

  private papelSelecionadoId: number | null = null;
  private selecionadosIds: Set<number> = new Set();

  constructor(
    private gerenciarPerfisUsuariosApiService: GerenciarPerfisUsuariosApiService,
    private messageService: MessageService,
  ) { }

  public onItemSelecionado(item: ItemSelecao): void {
    this.papelSelecionadoId = item.id;
    const papel = this.papeis.find(p => p.id === item.id)!;
    this.papelSelecionadoEhAdmin = papel.nome === NOME_PAPEL_ADMIN;
    this.tituloDireita = `Permissões de ${papel.nome}`;
    this.selecionadosIds = new Set(papel.permissoes.map(p => p.id));
    this.computarItensDireita();
  }

  public onToggleItem(evento: { item: ItemSelecao; checked: boolean }): void {
    if (evento.checked) {
      this.selecionadosIds.add(evento.item.id);
    } else {
      this.selecionadosIds.delete(evento.item.id);
    }
    const item = this.itensDireita.find(i => i.id === evento.item.id);
    if (item) item.checado = evento.checked;
  }

  public onSalvar(evento: { esquerdaId: number }): void {
    this.salvando = true;
    const direitaIds = [...this.selecionadosIds];
    this.gerenciarPerfisUsuariosApiService.editarPermissoesPapel(evento.esquerdaId, direitaIds).subscribe({
      next: () => {
        const papel = this.papeis.find(p => p.id === evento.esquerdaId)!;
        const novasPermissoes = this._permissoes.filter(p => direitaIds.includes(p.id));
        const papelAtualizado: Papel = { ...papel, permissoes: novasPermissoes };

        this.papeisChange.emit(
          this.papeis.map(p => p.id === papelAtualizado.id ? papelAtualizado : p)
        );

        this.messageService.showToastSuccess(`Permissões de "${papelAtualizado.nome}" atualizadas com sucesso.`);
        this.salvando = false;
      },
      error: () => {
        this.salvando = false;
      }
    });
  }

  public filtrar(valor: string): void {
    this.paineis.filtrar(valor);
  }

  private computarItensDireita(): void {
    this.itensDireita = [...this._permissoes]
      .sort((a, b) => a.modulo - b.modulo)
      .map(p => ({
        id: p.id,
        label: p.nome,
        sublabel: p.descricao,
        grupo: ModuloEnumNome.get(p.modulo)!,
        checado: this.selecionadosIds.has(p.id),
        bloqueado: this.papelSelecionadoEhAdmin,
        tooltipBloqueado: 'As permissões do papel ADMIN não podem ser alteradas',
      }));
  }
}
